import { Button, Flex, Popup } from '@approvalmax/ui/src/components';
import { useAtomValue } from 'jotai';
import { useDispatch } from 'modules/react-redux';
import { reloadRequestList } from 'pages/requestList/actions';
import { memo, useCallback, useState } from 'react';
import { NetSuiteMatchingLine } from 'shared/hooks/(matchings)';

import { netSuiteSourceMatchingLineState } from '../../NetSuiteMatchingPopup.states';
import { PurchaseOrdersList } from '../PurchaseOrdersList/PurchaseOrdersList';
import { SourceLineInformation } from '../SourceLineInformation/SourceLineInformation';
import { useCreateMatching } from './Content.hooks';
import { messages } from './Content.messages';
import { ContentProps } from './Content.types';

export const Content = memo((props: ContentProps) => {
    const { request, onClose } = props;

    const [selectedLine, setSelectedLine] = useState<NetSuiteMatchingLine>();

    const sourceLine = useAtomValue(netSuiteSourceMatchingLineState);

    const { createMatching, isLoadingCreateMatching } = useCreateMatching(sourceLine?.lineType);

    const dispatch = useDispatch();

    const onSave = useCallback(() => {
        createMatching(
            {
                params: {
                    path: {
                        companyId: request.companyId,
                        sourceRequestId: request.id,
                        sourceLineNumber: sourceLine?.lineNumber,
                        targetRequestId: selectedLine?.requestId,
                        targetLineNumber: selectedLine?.lineNumber,
                    },
                },
            },
            {
                onSuccess: () => {
                    dispatch(reloadRequestList());
                    onClose();
                },
            }
        );
    }, [request, sourceLine, selectedLine, createMatching, onClose, dispatch]);

    return (
        <>
            <Popup.Header
                title={messages.matchLines}
                actionsSize='xsmall'
                actions={
                    <Button
                        title={messages.match}
                        color='blue80'
                        size='small'
                        onClick={onSave}
                        disabled={!selectedLine}
                        progress={isLoadingCreateMatching}
                    >
                        {messages.match}
                    </Button>
                }
            />

            <Popup.Body spacing='20 40'>
                <Flex direction='column' height='100%'>
                    <SourceLineInformation request={request} />

                    <PurchaseOrdersList
                        request={request}
                        selectedLine={selectedLine}
                        setSelectedLine={setSelectedLine}
                    />
                </Flex>
            </Popup.Body>
        </>
    );
});

Content.displayName = 'Content';
